import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

const KEY = "rcc_alerts_seen";
const POSITIVE = ["interested", "meeting_request", "candidate_details", "pricing", "referral"];
const seenIds = () => { try { return new Set(JSON.parse(localStorage.getItem(KEY) || "[]")); } catch { return new Set(); } };
const name = (o) => (typeof o === "string" ? o : o?.name || o?.company_name || o?.contact_name || "");

// Fallback when GET /admin/rcc/alerts isn't live: derive from the dashboard.
const fromDashboard = (d) => [
  ...(d.hot_companies || []).map((o) => ({ id: `hot:${o?.id || name(o)}`, type: "hot_company", title: `Hot company: ${name(o)}`, detail: o?.reason || o?.signal || (o?.opportunity_score ? `Opportunity score ${o.opportunity_score}` : ""), link: "/admin/rcc/companies" })),
  ...(d.needs_reply || []).filter((o) => typeof o !== "object" || !o.label || POSITIVE.includes(o.label))
    .map((o) => ({ id: `reply:${o?.id || name(o)}`, type: "positive_reply", title: `Positive reply from ${o?.contact_name || name(o)}${o?.company_name && o?.contact_name ? ` (${o.company_name})` : ""}`, detail: o?.subject || "", link: "/admin/rcc/inbox", at: o?.last_at })),
];

const fetchAlerts = async () => {
  try { const { data } = await api.get("/admin/rcc/alerts"); return data?.items || []; }
  catch (e) { if (e.response?.status !== 404) throw e; const { data } = await api.get("/admin/rcc/dashboard"); return fromDashboard(data || {}); }
};

export const useRccAlerts = (every = 60000) => {
  const [items, setItems] = useState([]);
  const [seen, setSeen] = useState(seenIds);
  const load = useCallback(() => fetchAlerts().then(setItems).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, every); return () => clearInterval(t); }, [load, every]);
  const unread = items.filter((a) => !a.read && !seen.has(a.id));
  const markRead = (ids) => {
    const next = new Set([...seen, ...ids]);
    localStorage.setItem(KEY, JSON.stringify([...next].slice(-500)));
    setSeen(next);
    api.post("/admin/rcc/alerts/read", { ids }).catch(() => {});
  };
  return { items, unread, markRead };
};
